import {FetchAccountDetailsProvider} from "../../../../components/payouts/v2/connect-bank-account/context/fetch-account-details.context";
import {PayoutSettingsProvider} from "../../../../components/payouts/v2/tabs/payout-settings-tab/context";
import {IOnboardingStepProps} from "../../i-step";
import {OnboardingAccountConnectionStepFlow} from "./flow";
interface OnboardingAccountConnectionStepProps extends IOnboardingStepProps {}
export function OnboardingAccountConnectionStep({
  updateStep,
  currentStep,
}: OnboardingAccountConnectionStepProps) {
  return (
    <div>
      <FetchAccountDetailsProvider>
        <PayoutSettingsProvider>
          <OnboardingAccountConnectionStepFlow
            currentStep={currentStep}
            updateStep={updateStep}
          />
        </PayoutSettingsProvider>
      </FetchAccountDetailsProvider>
    </div>
  );
}
